import { useMenuStore } from '@/store/menuStore'

type MenuLike = {
  path?: string
  rawPath?: string
  component?: string
  children?: MenuLike[]
}

const normalizeSlash = (value: string) => value.replace(/\\/g, '/').replace(/\/+/g, '/')

const trimSlashes = (value: string) => normalizeSlash(value).replace(/^\/+|\/+$/g, '')

const normalizeComponentPath = (value: string) => {
  let key = normalizeSlash(value || '').trim()
  key = key
    .replace(/^\.\//, '')
    .replace(/^@\/views\//, '')
    .replace(/^\/?src\/views\//, '')
    .replace(/^\/?views\//, '')
    .replace(/^\/+/, '')

  if (!key) return ''
  if (!/\.vue$/i.test(key)) {
    key = key.endsWith('/') ? `${key}index.vue` : `${key}/index.vue`
  }
  return key.toLowerCase()
}

export const joinMenuPath = (basePath: string, segment: string) => {
  const base = trimSlashes(basePath)
  const child = trimSlashes(segment)
  return `/${[base, child].filter(Boolean).join('/')}`
}

const findMenuPathByComponent = (menus: MenuLike[], componentPath: string): string => {
  const target = normalizeComponentPath(componentPath)
  if (!target) return ''

  for (const menu of menus) {
    const menuComponent = normalizeComponentPath(menu.component || menu.rawPath || '')
    if (menuComponent === target && menu.path) {
      return menu.path
    }

    if (Array.isArray(menu.children) && menu.children.length > 0) {
      const found = findMenuPathByComponent(menu.children, componentPath)
      if (found) return found
    }
  }

  return ''
}

export const getMenuPathByComponent = (componentPath: string, fallbackPath = '') => {
  const menuStore = useMenuStore()
  return findMenuPathByComponent(menuStore.sidebarMenus as MenuLike[], componentPath) || fallbackPath
}

export const getMenuChildPathByComponent = (
  componentPath: string,
  childSegment: string,
  fallbackPath = ''
) => {
  const parentPath = getMenuPathByComponent(componentPath)
  return parentPath ? joinMenuPath(parentPath, childSegment) : fallbackPath
}
